import Styled from 'styled-components'

export const Container = Styled.div`
`


export const H1 = Styled.h1`
`

export const CotainerProduct = Styled.div`
`

export const Cashback = Styled.div`
`

export const TitleProduct = Styled.p`
`

/* Desktop: grade de produtos em 4 colunas, alinhada a 1320/32 */
export const PageWrap = Styled.div`
  @media (min-width: 1024px) {
    .container { max-width: 1320px; padding-left: 32px; padding-right: 32px; }
    .mySwiper { overflow: visible; }
    .mySwiper > .swiper-wrapper { display: block; }
    .product-grid .col-6 { flex: 0 0 25%; max-width: 25%; width: 25%; }
  }
`